import { Link } from 'react-router-dom';
import { useI18nTranslation } from '../../lib/use-i18n-translation';

export const NotFoundPage = () => {
  const { t } = useI18nTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="max-w-sm text-center">
        <h1 className="text-2xl font-semibold text-foreground">{t('errors.notFoundTitle')}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{t('errors.notFoundBody')}</p>
        <Link
          to="/"
          className="mt-6 inline-flex h-9 items-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          {t('errors.backHome')}
        </Link>
      </div>
    </div>
  );
};
